import type { AssetSummary } from '@protoss/shared';
import { Avatar } from '@protoss/ui';
import { useProtectedAssetUrl } from '../hooks/useProtectedAssetUrl';

interface CustomerAvatarProps {
  name?: string | null;
  asset?: AssetSummary | null;
  srcOverride?: string | null;
  alt?: string;
  size?: 'sm' | 'md' | 'lg';
  shape?: 'circle' | 'square';
  className?: string;
}

/**
 * CustomerAvatar wraps the shared Avatar component with authenticated asset URL resolution.
 */
export function CustomerAvatar({
  name,
  asset,
  srcOverride,
  alt,
  size = 'md',
  shape = 'circle',
  className,
}: CustomerAvatarProps) {
  const protectedSrc = useProtectedAssetUrl(srcOverride ? null : asset);

  return (
    <Avatar
      src={srcOverride ?? protectedSrc ?? undefined}
      name={name ?? undefined}
      alt={alt}
      size={size}
      shape={shape}
      className={className}
      loading={size === 'sm' ? 'lazy' : 'eager'}
      decoding="async"
    />
  );
}
